<div class="container-fluid custom-width">
    <div class="row slider mt-3">
        <div class="col-lg-12">
            <p-carousel [value]="gallery" [numVisible]="1" [numScroll]="1" [circular]="false">
                <ng-template let-image pTemplate="item">
                    <div class="card">
                        <img [src]="image.image" alt="Gallery-img" class="carousel-image">
                    </div>
                </ng-template>
            </p-carousel>
        </div>
    </div>
    <div class="row about">
        <div class="col-lg-6 mb-4">
            <div class="card left">
                <h2>Who are we</h2>
                <p>At Jheevarekha Mills Private Limited, we are more than just a textile company; we are purveyors of
                    quality, reliability, and innovation. With a rich legacy spanning over 17 years, we have established
                    ourselves as leaders in the global textile industry, specializing in the production of woven
                    fabrics.</p>

            </div>
        </div>
        <div class="col-lg-6 mb-4">
            <div class="card right">
                <h2>Our Mission</h2>
                <p>Our mission is simple yet profound: to remain at the forefront of a rapidly evolving and progressive
                    industry. We achieve this by relentlessly pursuing technical excellence, embracing innovation, and
                    fostering enduring relationships with our valued customers.</p>
            </div>
        </div>
    </div>
    <div class="row sets-us">
        <div class="col-lg-12">
            <h2>What Sets Us Apart</h2>
            <p>What sets us apart is our unwavering commitment to excellence. Our team of skilled professionals ensures
                that every yard of fabric produced meets the highest standards of quality and craftsmanship. From
                classic weaves to cutting-edge designs, we offer a diverse range of fabrics tailored to meet the unique
                needs of our clientele.</p>
        </div>
    </div>
    <div class="container-fluid custom-width prod">
        <div class="row g-2">
            <div class="col-lg-4">
                <div class="row left-side">
                    <div class="mb-2">
                        <img src="/assets/img/production.png" alt="">
                    </div>
                    <div class="card first">
                        <h5>2 Lakhs Square Feet </h5>
                        <p>Our Manufacturing Area</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-8 prod-content">
                <h2 class="mb-2">Production</h2>
                <ul>
                    <li>Our Annual Production = 15 million metres</li>
                    <li>We are Specialised in all kinds of dobby designs upto 16 frames</li>
                    <li>Top Beams and Name writer options also Available</li>
                    <li>We Accept small orders also</li>
                    <li>Production Range = 40,000 meters/Day</li>
                    <li>Our strong point lies in the professionalism, high quality, cost effective and timely delivery.
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row production">
        <div class="col-lg-12">
            <h2 class="head">Our Production Range</h2>
        </div>
        <div class="col-lg-6 mb-4">
            <div class="card left">
                <h2>Design and Variety</h2>
                <p>Organic, BCI, Lycra, Lurex, Cotton Flax, Tencel, Excel, Slub, Rayon, Poly cotton, Lea, Linen, Modal,
                    Dobby.</p>
            </div>
        </div>
        <div class="col-lg-6 mb-4">
            <div class="card right">
                <h2>Width (Narrow to wider width)</h2>
                <p>Airjet 190cm - 63" - 71"</p>
                <p>Airjet 280cm - 48" - 104"</p>
                <p>Airjet 340cm -63"- 127"</p>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid experience-wrapper">
    <div class="row">
        <div class="col-lg-12 custom-width experiance">
            <h2>Experience the Jheevarekha Difference</h2>
            <p>Discover why leading garment manufacturers worldwide trust Jheevarekha Textile for their woven fabric
                needs. Experience the difference that expertise, dedication, and innovation can make in your textile
                sourcing journey.</p>
            <div class="buttons">
                <p-button type="button" label="View Products"
                    styleClass="experiance-button p-button-rounded"></p-button>
                <p-button type="button" label="Contact Us" styleClass="experiance-button p-button-rounded"></p-button>
            </div>
        </div>
    </div>
</div>